export default __webpack_public_path__ + "static/media/pc.a2f6db8f.png";